import { mergeStyleSets, getTheme } from "@fluentui/react/lib/Styling";

const theme = getTheme();

const styles = mergeStyleSets({
  experimentDetails: {
    fontFamily: "inherit",
    minHeight: 0,
    flex: "0 0 auto",
  },

  experimentDetailsAccordionClosed: {
    height: 65,
    maxHeight: 65,
  },

  experimentDetailsDetails: {
    marginBottom: "16px",
    border: `1px solid ${theme.palette.neutralLight}`,
    borderRadius: "4px",
    background: theme.palette.white,
  },
  experimentDetailsAccordionPanel: {
    "& .fui-AccordionPanel": {
      margin: 0,
    },
  },
  experimentDetailsAccordionHeader: {
    paddingTop: 15,
    paddingBottom: 5,
    "& .fui-AccordionHeader": {
      margin: 0,
    },
    "& .fui-AccordionHeader__button": {
      minHeight: 0,
    },
  },
  experimentDetailsAccordionHeaderLabel: {},
  experimentDetailsCommandBar: {
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
    paddingLeft: "0",
    paddingRight: "0",
    background: "transparent",

    "& .ms-CommandBar": {
      justifyContent: "flex-start",
      paddingLeft: 10,
    },
  },
});

const stackTokens = { childrenGap: 16 };

export { styles, stackTokens };
